/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DockerAuthorizationResponse
 *
 */
// create custom validators for the regexes
export interface DockerAuthorizationResponse {
    /**
     *
     * #type string
     * #memberof DockerAuthorizationResponse
        
        
         */
    bodyString: string;
    /**
     *
     * #type string
     * #memberof DockerAuthorizationResponse
        
        
         */
    bodyHmac: string;
}
/**
 * Check if a given object implements the DockerAuthorizationResponse interface.
 */
export function instanceOfDockerAuthorizationResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bodyString" in value;
    isInstance = isInstance && "bodyHmac" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DockerAuthorizationResponseTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerAuthorizationResponse => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerAuthorizationResponse => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.bodyString && "string" === typeof input.bodyHmac && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["bodyString", "bodyHmac"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerAuthorizationResponse => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.bodyString || $guard(_exceptionable, {
                    path: _path + ".bodyString",
                    expected: "string",
                    value: input.bodyString
                })) && ("string" === typeof input.bodyHmac || $guard(_exceptionable, {
                    path: _path + ".bodyHmac",
                    expected: "string",
                    value: input.bodyHmac
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["bodyString", "bodyHmac"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerAuthorizationResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerAuthorizationResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerAuthorizationResponseTypiaAssertStringify = (input: DockerAuthorizationResponse): string => {
    return ((input: any): string => { const assert = (input: any): DockerAuthorizationResponse => {
        const __is = (input: any): input is DockerAuthorizationResponse => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).bodyString && "string" === typeof (input as any).bodyHmac);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerAuthorizationResponse => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.bodyString || $guard(_exceptionable, {
                    path: _path + ".bodyString",
                    expected: "string",
                    value: input.bodyString
                })) && ("string" === typeof input.bodyHmac || $guard(_exceptionable, {
                    path: _path + ".bodyHmac",
                    expected: "string",
                    value: input.bodyHmac
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerAuthorizationResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerAuthorizationResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerAuthorizationResponse): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"bodyString":${$string((input as any).bodyString)},"bodyHmac":${$string((input as any).bodyHmac)}}`;
    }; return stringify(assert(input)); })(input);
};
export const DockerAuthorizationResponseValidatorShape = {
    'bodyString': yup.string().defined(),
    'bodyHmac': yup.string().defined(),
};
export const DockerAuthorizationResponseValidator = yup.object().shape(DockerAuthorizationResponseValidatorShape);
export const DockerAuthorizationResponseStringifyShapeProperties: ObjectSchema['properties'] = {
    'bodyString': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'bodyHmac': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const DockerAuthorizationResponseStringifyShape: ObjectSchema = {
    title: 'DockerAuthorizationResponse Stringifier',
    type: 'object',
    properties: {
        ...DockerAuthorizationResponseStringifyShapeProperties
    },
    required: [
        'bodyString',
        'bodyHmac',
    ],
};
export const DockerAuthorizationResponseStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerAuthorizationResponseStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerAuthorizationResponseStringify: (data: DockerAuthorizationResponse) => string = DockerAuthorizationResponseStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerAuthorizationResponseFromJSON(json: any): DockerAuthorizationResponse {
    return DockerAuthorizationResponseFromJSONTyped(json, false);
}
export function DockerAuthorizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerAuthorizationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'bodyString': json['bodyString'],
        'bodyHmac': json['bodyHmac'],
    };
}
export function DockerAuthorizationResponseToJSON(value?: DockerAuthorizationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bodyString': value.bodyString,
        'bodyHmac': value.bodyHmac,
    };
}
